import { QueryClient } from 'react-query';
import { tagAnalysisQueryKeys } from './tag-analysis';
import { taxonomyQueryKeys } from './taxonomy';

export const tagQueryKeys = {
  tag: 'TAG',
  tagExists: 'TAG_EXISTS',
  tagsByDocument: 'TAGS_BY_DOCUMENT',
  tagsByDocumentPaginated: 'TAGS_BY_DOCUMENT_PAGINATED',
  tagsByElement: 'TAGS_BY_ELEMENT',
} as const;

// The document-scoped tag views + (globally) the calculations that any tag
// mutation can change — mirrors the original inline invalidations exactly.
const invalidateDocumentScoped = (queryClient: QueryClient, documentSuperId: number): void => {
  queryClient.invalidateQueries([tagQueryKeys.tagsByDocument, documentSuperId]);
  queryClient.invalidateQueries([tagQueryKeys.tagsByDocumentPaginated, documentSuperId]);
  queryClient.invalidateQueries([tagAnalysisQueryKeys.analysis, documentSuperId]);
  queryClient.invalidateQueries(taxonomyQueryKeys.calculations);
};

export const invalidateOnTagCreate = (queryClient: QueryClient, vars: { documentSuperId?: number; onId?: string | null }): void => {
  if (vars.documentSuperId) {
    invalidateDocumentScoped(queryClient, vars.documentSuperId);
  }
  if (vars.onId) {
    queryClient.invalidateQueries([tagQueryKeys.tagsByElement, vars.onId]);
  }
};

export const invalidateOnBatchCreate = (queryClient: QueryClient, documentSuperId?: number): void => {
  if (documentSuperId) {
    invalidateDocumentScoped(queryClient, documentSuperId);
  }
};

export const invalidateOnBlockChain = (queryClient: QueryClient, documentSuperId?: number): void => {
  if (documentSuperId) {
    invalidateDocumentScoped(queryClient, documentSuperId);
  }
};

export const invalidateOnContinue = (queryClient: QueryClient, vars: { documentSuperId?: number; onId?: string | null }): void => {
  if (vars.documentSuperId) {
    invalidateDocumentScoped(queryClient, vars.documentSuperId);
  }
  if (vars.onId) {
    queryClient.invalidateQueries([tagQueryKeys.tagsByElement, vars.onId]);
  }
};

export const invalidateOnTagUpdate = (queryClient: QueryClient, vars: { id: string; documentSuperId?: number }): void => {
  queryClient.invalidateQueries([tagQueryKeys.tag, vars.id]);
  if (vars.documentSuperId) {
    invalidateDocumentScoped(queryClient, vars.documentSuperId);
  }
  queryClient.invalidateQueries([tagQueryKeys.tagsByElement]);
};

export const invalidateOnValueSave = (queryClient: QueryClient, documentSuperId?: number): void => {
  if (documentSuperId) {
    invalidateDocumentScoped(queryClient, documentSuperId);
  }
  queryClient.invalidateQueries([tagQueryKeys.tagsByElement]);
};

export const invalidateOnTagDelete = (queryClient: QueryClient, vars: { id: string; documentSuperId?: number }): void => {
  queryClient.invalidateQueries([tagQueryKeys.tag, vars.id]);
  if (vars.documentSuperId) {
    invalidateDocumentScoped(queryClient, vars.documentSuperId);
  }
  queryClient.invalidateQueries([tagQueryKeys.tagsByElement]);
};
